import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3, FiEye } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchFormData, formatDateOnly } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const ExpenseTable = ({ filteredData = null, permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [branchData, setBranchData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchbranchData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchFormData("expense/getAll", formData, "POST");

      if (result) {
        const branch = result.data || [];
        setBranchData(branch);
      }
    } catch (error) {
      console.error("Failed to fetch expenses:", error);
      Swal.fire("Error", "Failed to load expense data.", "error");
    } finally {
      Swal.close();
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("id", Id);
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    try {
      const result = await fetchFormData(
        `expense-list/toggle-status/${Id}`,
        formData,
        "POST"
      );

      if (result && result.code === 200) {
        await fetchbranchData();
        topTost({
          title: result?.message || "Status updated successfully",
          icon: "success",
        });
      } else {
        topTost({
          title: "Failed to update status",
          icon: "error",
        });
      }
    } catch (error) {
      topTost({
        title: "Unexpected error occurred",
        icon: "error",
      });
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const is_active = row.original.status;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() => navigate(`/expense/history/${id}`)}
                      title="Task History"
                    >
                      <FiEye size={16} />
                    </span>
                  )}
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/master/edit-expense/${id}?id=${M_id}`)
                      }
                    >
                      <FiEdit3 size={16} />
                    </span>
                  )}
                  {permission?.pf_status === 1 &&
                    (is_active === 1 ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => {
        const val = info.getValue(); // expected to be 1 or 0 (number)
        const isActive = val === 1;

        const label = isActive ? "Approved " : "Pending";
        const styles = {
          backgroundColor: isActive ? "#cce5ff" : "#fff3cd", // Sky blue / Light yellow
          color: isActive ? "#004085" : "#856404", // Dark blue / Dark yellow
          padding: "4px 10px",
          display: "inline-block",
          fontWeight: "bold",
          fontSize: "12px",
          textAlign: "center",
        };

        return <span style={styles}>{label}</span>;
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "transaction_id",
      header: () => "Transaction ID",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "expense_category_name",
      header: () => "Expense Category",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "amount",
      header: () => "Amount",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "sectionamount",
      header: () => "Sanction Amount",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "employee_name",
      header: () => "Employee",
      cell: (info) => {
        const name = info.getValue();
        return name ? name.charAt(0).toUpperCase() + name.slice(1) : "-";
      },
      defaultIsVisible: true,
    },
    {
      accessorKey: "travelling_description",
      header: () => "Travelling Description",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "travelling_date",
      header: () => "Travelling Date",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "created_at",
      header: () => "Created At",

      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    const shouldFetch =
      !Array.isArray(filteredData) || filteredData.length === 0;

    if (shouldFetch) {
      fetchbranchData();
    } else {
      setBranchData(filteredData); //  Use filtered data passed as prop
    }
  }, [filteredData]);
  return (
    <>
      <Table data={branchData} columns={columns} />
    </>
  );
};

export default ExpenseTable;
